export const experiences = [
    {
        "company": "CONTUS",
        "location": "Chennai",
        "position": "Senior Application Developer ",
        "website": "",
        "startDate": "Nov 2016",
        "highlights": [
            "Plan, develop and implement successful large-scale projects from conception to completion",
            "Ability to understand/comment on functional requirements and design documents",
            "Involved in analysis, design, and development, customization, testing and troubleshooting",
            "Project handling on all phases of the development life cycle, from analysis to deployment on the production environment, to post-release support",
            "Communicating with the client team, mobile and web team for the development, integration and troubleshooting",
        ],
        "endDate": "Present"
    }
]